import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { guarantee } from '../data/content';
export function Guarantee() {
  return <section className="bg-night-panel" data-id="element-84" data-mp="1o33u6h0ytshr">
      <div className="mx-auto max-w-content px-5 pb-14 sm:px-6 lg:pb-20" data-id="element-85" data-mp="223ek9hugb31v">
        <div className="mx-auto max-w-2xl rounded-3xl border border-gold-soft/40 bg-night p-7 text-center sm:p-10" data-id="element-86" data-mp="221by58wf5u2f">
          <ShieldCheckIcon className="mx-auto h-9 w-9 text-gold-soft" aria-hidden="true" data-id="element-87" data-mp="19eqvvdeenxk3" />
          <h2 className="mt-5 font-display text-2xl font-semibold leading-tight text-parchment sm:text-3xl" data-id="element-88" data-mp="19cefv5s7jx9o">
            {guarantee.title}
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-parchment/75" data-id="element-89" data-mp="1j5lsnbpa2fjs">
            {guarantee.body}
          </p>
          <p className="mt-5 font-display text-lg font-semibold italic text-gold-soft" data-id="element-90" data-mp="1ecizv5sbra4n">
            {guarantee.claim}
          </p>
        </div>
      </div>
    </section>;
}